import React, { useId, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntercom } from 'react-use-intercom';
import { useAppDispatch } from 'redux/hooks';
import { ecomThunk } from 'redux/slices/ecoms-slice';
import { MarketDrivenShippingSwitchBackConfirmModal } from './modals/switch-back/MarketDrivenShippingSwitchBackConfirmModal';

// Shown when the ecom is already ACTIVE on market-driven shipping but the shop has switched back to
// delivery profiles in Shopify (`shop.features.marketDrivenShipping` is false). The ecom's status
// has to be changed on our side as well: the merchant can set it back to LEGACY through a confirm
// modal, or ask support.
export const MarketDrivenShippingSwitchedBackBanner: React.FC = () => {
    const { t } = useTranslation();
    const intercom = useIntercom();
    const dispatch = useAppDispatch();

    const confirmModalId = useId();
    const confirmModalRef = useRef<HTMLElementTagNameMap['s-modal']>(null);

    // Refetching the ecom picks up its new LEGACY status, which takes this banner away on its own.
    const handleConfirmSwitchBack = () => {
        confirmModalRef.current?.hideOverlay();
        shopify.toast.show(t('MARKET_DRIVEN_SHIPPING_SWITCHED_BACK_BANNER.SUCCESS_TOAST'));
        dispatch(ecomThunk());
    };

    return (
        <>
            <s-banner heading={t('MARKET_DRIVEN_SHIPPING_SWITCHED_BACK_BANNER.HEADING')} tone="warning">
                <div className="flex flex-col gap-3">
                    <s-text>{t('MARKET_DRIVEN_SHIPPING_SWITCHED_BACK_BANNER.DESCRIPTION')}</s-text>
                    <div className="flex gap-2">
                        <s-button variant="primary" commandFor={confirmModalId} command="--show">
                            {t('MARKET_DRIVEN_SHIPPING_SWITCHED_BACK_BANNER.SWITCH_BACK_BUTTON')}
                        </s-button>
                        <s-button onClick={() => intercom.showNewMessage()}>
                            {t('GENERAL_ERROR_BANNER.CONTACT_SUPPORT')}
                        </s-button>
                    </div>
                </div>
            </s-banner>

            <MarketDrivenShippingSwitchBackConfirmModal
                id={confirmModalId}
                modalRef={confirmModalRef}
                onConfirm={handleConfirmSwitchBack}
            />
        </>
    );
};
